import React, { memo, useContext } from 'react'

import { bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { closeDetachedHistory } from 'Pods/ThreeDStudio/Store/actions/ui'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import CategoryFilters from './Components/CategoryFilters/CategoryFilters'
import DetachedWindow from './Components/DetachedWindow/DetachedWindow'
import EmptyState from './Components/EmptyState/EmptyState'
import Grid from './Components/Grid/Grid'
import Header from './Components/Header/Header'
import Loading from './Components/Loading/Loading'
import Tree from './Components/Tree/Tree'
import ViewToggle from './Components/ViewToggle/ViewToggle'
import useCategoryFilters from './Hooks/useCategoryFilters'
import useHistoryView from './Hooks/useHistoryView'
import useVariationsTab from './Hooks/useVariationsTab'

function VariationsTab({ isDetached = false }) {
  const t = useTranslation()
  const { treeViewEnabled } = useContext(ThreeDStudioPageContext)
  const {
    variations,
    uploadedAsset,
    isLoading,
    isEnhanced,
    assignMain,
    deleteVariation,
    ...gridProps
  } = useVariationsTab()
  const { selectedCategory, countByCategory, filteredVariations, selectCategory } = useCategoryFilters(variations)

  const isFiltered = selectedCategory != null
  const { view, isTreeView, visibleIds, setView } = useHistoryView(treeViewEnabled, isFiltered, filteredVariations)
  const title = t('viewerSidebar.enhance.variations.historyTitle')

  const content = (
    <>
      {treeViewEnabled && <ViewToggle view={view} onChange={setView} />}
      <CategoryFilters
        allCount={variations.length + (uploadedAsset ? 1 : 0)}
        countByCategory={countByCategory}
        selectedCategory={selectedCategory}
        onSelect={selectCategory}
      />
      {isLoading && <Loading />}
      {!isLoading && variations.length > 0 && isTreeView && (
        <Tree
          variations={variations}
          visibleIds={visibleIds}
          positionById={gridProps.positionById}
          openedModelId={gridProps.openedModelId}
          previewedRunId={gridProps.previewedRunId}
          isUploadedModelLoaded={gridProps.isUploadedModelLoaded}
          isActionLoading={gridProps.isActionLoading}
          onSetAsMain={assignMain}
          onDelete={deleteVariation}
        />
      )}
      {!isLoading && variations.length > 0 && !isTreeView && (
        <Grid
          {...gridProps}
          variations={filteredVariations}
          uploadedAsset={isFiltered ? null : uploadedAsset}
          canOpenRelatedTab={!isDetached}
          isWide={isDetached}
          showInfo
          onSetAsMain={assignMain}
          onDelete={deleteVariation}
        />
      )}
      {!isLoading && !isEnhanced && <EmptyState />}
    </>
  )

  if (isDetached) {
    return (
      <DetachedWindow title={title} onClose={closeDetachedHistory}>
        {content}
      </DetachedWindow>
    )
  }

  return (
    <div className="enhance-model-panel__tab">
      <Header title={title} canDetach isDetachDisabled={isLoading} />
      {content}
    </div>
  )
}

VariationsTab.propTypes = {
  isDetached: bool,
}

export default memo(VariationsTab)
